import { Box, Breadcrumbs, Link, useTheme } from '@mui/material'
import { useAppDispatch, useAppSelector } from '../../store/Hooks'
import { changeRoute } from '../../store/slices/SessionSlice'
import StaleIndicator from '../controls/stale/StaleIndicator'
import Logo from '../presentation/Logo'
import RoutingManager from '../routing/Routing'
import Helper from '../../helpers/Helper'
import RouteIcon from '../routing/RouteIcon'
import SmartTypography from '../controls/SmartTypography'

function LayoutTopBar() {
    const dispatch = useAppDispatch()
    const theme = useTheme()
    const history = useAppSelector(s => s.session.routeHistory)

    return (
        <Box flex={1} display='flex' flexDirection='row' sx={{ backgroundColor: theme.palette.primary.main }}>
            <Box
                width='var(--left-nav-width)'
                onClick={() => dispatch(changeRoute({ route: 'overview' }))}
                maxHeight='100%'
                p={1}
                pl={2}
                display='flex'
                sx={{ cursor: 'pointer' }}
                alignItems='center'>
                <Logo width={160} />
            </Box>
            <Box flex={1} p={1} alignItems='center' display='flex'>
                <Breadcrumbs maxItems={5} separator='/'>
                    {history.map((x, i) => {
                        const routeData = RoutingManager.get(x.route)
                        const routeName = Helper.hasVal(x.customRouteName) ? x.customRouteName : routeData?.label
                        const isLast = i === (history.length - 1)
                        return (
                            <Link
                                key={x.route + i}
                                href='/'
                                underline='hover'
                                color={theme.palette.primary['50']}
                                sx={{ display: 'flex', alignItems: 'center' }}
                                onClick={e => {
                                    e.preventDefault()
                                    dispatch(changeRoute(x))
                                }}>
                                <RouteIcon icon={routeData?.route} />
                                <SmartTypography
                                    charLimit={12}
                                    ml={0.5}
                                    fontWeight={isLast ? theme.typography.fontWeightMedium : theme.typography.fontWeightLight}>
                                    {routeName}
                                </SmartTypography>
                            </Link>
                        )
                    })}
                </Breadcrumbs>
            </Box>
            <StaleIndicator />
        </Box>
    )
}

export default LayoutTopBar
